// extracted by mini-css-extract-plugin
export default {"meatball":"role-toolbar__meatball--s_dcC","not-allowed":"role-toolbar__not-allowed--BRBuv","notAllowed":"role-toolbar__not-allowed--BRBuv"};